export const getBackgroundColor =
  ({ $filled, theme: { colors: { dmiWhite, primary } } }) =>
    $filled ? primary : dmiWhite;
